import React from 'react';
import FamiliaAliancaApp from './FamiliaAliancaApp';

function App() {
  return <FamiliaAliancaApp />;
}

export default App;